/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Import_Drop_Frame_Convert_LabelInputs */

const en_subtitle_import_drop_frame_convert_label = /** @type {(inputs: Subtitle_Import_Drop_Frame_Convert_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop Frame Convert`)
};

const fr_subtitle_import_drop_frame_convert_label = /** @type {(inputs: Subtitle_Import_Drop_Frame_Convert_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversion drop frame`)
};

const de_subtitle_import_drop_frame_convert_label = /** @type {(inputs: Subtitle_Import_Drop_Frame_Convert_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop Frame Convert`)
};

const it_subtitle_import_drop_frame_convert_label = /** @type {(inputs: Subtitle_Import_Drop_Frame_Convert_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversione a frame eliminato`)
};

const ru_subtitle_import_drop_frame_convert_label = /** @type {(inputs: Subtitle_Import_Drop_Frame_Convert_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Преобразование кадров`)
};

const es_subtitle_import_drop_frame_convert_label = /** @type {(inputs: Subtitle_Import_Drop_Frame_Convert_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversión de fotogramas eliminados`)
};

const zh_cn2_subtitle_import_drop_frame_convert_label = /** @type {(inputs: Subtitle_Import_Drop_Frame_Convert_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`帧转换`)
};

const ja_subtitle_import_drop_frame_convert_label = /** @type {(inputs: Subtitle_Import_Drop_Frame_Convert_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドロップフレーム変換`)
};

const hi_subtitle_import_drop_frame_convert_label = /** @type {(inputs: Subtitle_Import_Drop_Frame_Convert_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ड्रॉप फ्रेम कन्वर्ट`)
};

const pt_pt2_subtitle_import_drop_frame_convert_label = /** @type {(inputs: Subtitle_Import_Drop_Frame_Convert_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converter quadro solto`)
};

/**
* | output |
* | --- |
* | "Drop Frame Convert" |
*
* @param {Subtitle_Import_Drop_Frame_Convert_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_import_drop_frame_convert_label = /** @type {((inputs?: Subtitle_Import_Drop_Frame_Convert_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Import_Drop_Frame_Convert_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_import_drop_frame_convert_label(inputs)
	if (locale === "de") return de_subtitle_import_drop_frame_convert_label(inputs)
	if (locale === "it") return it_subtitle_import_drop_frame_convert_label(inputs)
	if (locale === "ru") return ru_subtitle_import_drop_frame_convert_label(inputs)
	if (locale === "es") return es_subtitle_import_drop_frame_convert_label(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_import_drop_frame_convert_label(inputs)
	if (locale === "ja") return ja_subtitle_import_drop_frame_convert_label(inputs)
	if (locale === "hi") return hi_subtitle_import_drop_frame_convert_label(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_import_drop_frame_convert_label(inputs)
	return en_subtitle_import_drop_frame_convert_label(inputs)
});